import React,{useState,useEffect,useContext,createContext} from 'react'
import { useParams,Navigate,useNavigate } from 'react-router-dom'
import '../../css/style.css'
import {UserContext} from '../../context/UserContext'
import moment from 'moment'
import QRCode from "qrcode.react";
import leftArrow from  '../../css/images/left-arrow.png'
import {Form,Button,Container,Card,Alert,Table,Modal,Navbar,NavDropdown,Nav,Row,Col,Accordion} from 'react-bootstrap'
import join from './join.gif'

import Footer from '../Components/Footer'
import axios from 'axios'

export default function Events() {
    const {isAuth,setIsAuth}=useContext(UserContext)
    const {apiToken,setApiToken} = useContext(UserContext)
    const {userID,setUserID }= useContext(UserContext)
    const {usrPhoto,setUsrPhoto}= useContext(UserContext)
    const {firstName,lastName}= useContext(UserContext)
    const [isLoading,setIsLoading]=useState(false)
    const {sportID,langID}= useContext(UserContext)
    const [event,setEvent]=useState([])
    const [isAtendee,setIsAttendee]=useState(0)
    const [tag,setTag]=useState('')
    const [attendeeData,setAttendeeData]=useState({BarCode:'',Tag:'',IsScanned:0})
    const [justJoined,setJustJoined]=useState(false)
    const navigate=useNavigate()
    const {id}=useParams()


    useEffect(()=>{
        loadData()


        window.scrollTo({ top: 0, behavior: 'smooth' })
    },[])

    const loadData=()=>{
      setIsLoading(true)
      axios.get(process.env.REACT_APP_API_SERVER+'events/event/'+id+'/'+userID,{
        headers: {
            'Authorization': 'Bearer '+sessionStorage.getItem("token")
            }            
        })
      .then(res=>{
         //console.log(res.data)
          setEvent(res.data.results)
          if (res.data.attendee.length>0){
            setAttendeeData(res.data.attendee[0])
            setIsAttendee(1)
          }else{
            setIsAttendee(0)
            setAttendeeData({BarCode:'',Tag:'',IsScanned:0})         
          }

          setIsLoading(false)
      }).catch(err=>{
          setIsLoading(false)
          //console.log(err)
      })  

    
    }

    const unregister=()=>{
      setIsLoading(true)
      axios.get(process.env.REACT_APP_API_SERVER+'events/leaveevent/'+id+'/'+userID,{
        headers: {
            'Authorization': 'Bearer '+sessionStorage.getItem("token")
            }            
        })
      .then(res=>{
        navigate('/events')
      }).catch(err=>{
          setIsLoading(false)
          //console.log(err)
      })  

    
    }



    const joinEvent=(Tag)=>{
      setIsLoading(true)
      const obj={
        eventUUID:id,
        userUUID:userID,
        Tag
      }
      axios.post(process.env.REACT_APP_API_SERVER+'events/event',obj,{
        headers: {
            'Authorization': 'Bearer '+sessionStorage.getItem("token")
            }            
        })
      .then(res=>{

          setEvent(res.data.results)
          setIsAttendee(1)
          loadData()
          setIsLoading(false)
          setJustJoined(true)
          setTimeout(() => {
            setJustJoined(false)
          }, 5000);

      }).catch(err=>{
          setIsLoading(false)
          //console.log(err)
      })    

    }

    const eventsList=event.map(item=>{
      return(
        <>

        {justJoined &&
        <>
        <div className="settings-item" style={{alignContent:'center',alignItems:'center',justifyContent:'center',justifyItems:'center'}}>
          <h3>You are in!</h3>
        </div>
        <div className="settings-item" style={{alignContent:'center',alignItems:'center',justifyContent:'center',justifyItems:'center'}}>
          <img src={join} style={{width:'250px',height:'250px'}}/>  
        </div>
        </>
        }


        <div className="settings-item">
        <div className="setting-title">  
            <div className="setting-icon"><i className="bi bi-calendar-fill"></i></div>    
            <div className="setting-text">{item.Title}</div>    
        </div>


        
        <div className="setting-value">{moment(item.DateFrom).format('DD/MM/YYYY')} <br/>{item.Location}</div> 
        </div>
        <div className="settings-item" dangerouslySetInnerHTML={{ __html: item.Descr.replace(/\n/g, "<br>")}}/>
        

        
            
            {isAtendee==0 && 
              <>
              {item.AcceptParticipants==1 &&
              <Container
                fluid
                className="d-flex flex-column justify-content-center align-items-center"
              >
                <p align="center">
                <h3>Click on a category to join the event</h3>
                </p>
                {item.Tags.split(',').map(tag=>{
                  return(

                    <Button variant="dark" style={{width:'250px',marginBottom:'20px'}} onClick={()=>joinEvent(tag,item.UUID)}>{tag}</Button>
                  )
                })}
          
              </Container>
              }

              {item.AcceptParticipants==0 &&
              <Container
                fluid
                className="d-flex flex-column justify-content-center align-items-center"
              >
                <p align="center"><h3>Event is closed to new registrations</h3></p>

          
              </Container>
              }              
              </>
            }


            {isAtendee==1 &&
              <>
                
                 <div className="settings-item" style={{alignContent:'center',alignItems:'center',justifyContent:'center',justifyItems:'center'}}>
                    <h2>{attendeeData.Tag}</h2>
                  </div> 


                <div className="settings-item" style={{alignContent:'center',alignItems:'center',justifyContent:'center',justifyItems:'center'}}>
                  <QRCode
                  id="qr-gen"
                  value={`${attendeeData.BarCode}`}
                  size={150}
                  level={"H"}
                  includeMargin={true}
                  />
                </div>    
                <div className="settings-item" style={{alignContent:'center',alignItems:'center',justifyContent:'center',justifyItems:'center'}}>
                  <h2>{attendeeData.BarCode}</h2>
              </div> 
              {attendeeData.IsScanned==0 &&              
              <div className="settings-item" style={{alignContent:'center',alignItems:'center',justifyContent:'center',justifyItems:'center'}}>
                  <Button variant="warning"  onClick={()=>setIsAttendee(0)}>Change Category</Button>
                  &nbsp;&nbsp;
                  <Button variant="danger"  onClick={()=>unregister()}>Unregister</Button>
              </div>
              }   
              {attendeeData.IsScanned==1 &&              
              <div className="settings-item" style={{alignContent:'center',alignItems:'center',justifyContent:'center',justifyItems:'center'}}>
                  <h3>Barcode scanned on: {moment(attendeeData.ScanDate).format('DD/MM/YYYY')} </h3>
              </div>
              }   


              </>
            }

        
        
        

 
        </>
      )
    })




  return (
    <>
      <header>
          <div className="upper-section upper-dark">
            <div className="d-flex align-items-center">
            <div className="upper-arrow">
              <button onClick={()=>navigate('/events')}><img src={leftArrow}/></button>
            </div>
              <div className="upper-texts">
                <div className="text1-w">events</div>
                <div className="text2-g2">{firstName} {lastName}</div>
              </div>
            </div>
            <div onClick={()=>navigate('/profile/'+userID)}  className="upper-photo" style={{backgroundImage:'url('+usrPhoto+')'}}></div>
          </div>    
      </header>

         <section className="pb-4 section-margin">       
        
        {isLoading &&
          <div className="alert alert-warning" role="alert">
          Loading, please wait...
          </div>          
        }
        
        {!isLoading &&
            

          <>{eventsList}</>

            
        }
        </section>
  </>
  )
}
